import { initAdsenseOnPage } from '~/util/adsense'
import { isAdsDisabledRoute } from '~/util/adsense-routes'

export default defineNuxtPlugin((nuxtApp) => {
  const route = useRoute()
  const isNonPersonalized = false

  let lastPath = ''

  const run = async () => {
    if (isAdsDisabledRoute(route.path)) return
    if (route.path === lastPath) return
    lastPath = route.path

    await nextTick()
    initAdsenseOnPage(isNonPersonalized) // initAdsenseOnPage već radi idle unutra
  }

  nuxtApp.hook('app:mounted', run)  // prvi prikaz (onMounted ne radi u plugin-u: nema aktivne komponente)
  nuxtApp.hook('page:finish', run)  // SPA navigacija
})
